module.exports = __webpack_public_path__ + "media/dashboard/assets/images/alert-ca7226e56b4c6f21e41979c09ba14489.svg";